/* eslint-disable import/extensions */
/* eslint-disable import/no-unresolved */
import React from 'react'
import { graphql } from 'gatsby'

// Elements
import TitleDefault from 'components/elements/TitleDefault'

// Components
import SEO from 'components/shared/SEO'
import Layout from 'components/layout/Layout'

const PageTemplate = ({
  data: {
    page: { path, title, yoast_meta: yoast },
  },
}) => {
  return (
    <Layout>
      <SEO yoast={yoast} path={path} type="article" />

      <div className="container py-5">
        <TitleDefault>{title}</TitleDefault>
      </div>
    </Layout>
  )
}

export const pageQuery = graphql`
  query($wordpress_id: Int) {
    page: wordpressPost(wordpress_id: { eq: $wordpress_id }) {
      title
      path
      content

      yoast_meta {
        name
        content
        property
      }
    }
  }
`

export default PageTemplate
